import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Row, Table } from 'antd';
import moment from 'moment';

import {
  queryCancelCustomProtection,
  queryCustomProtectionList,
  querySaveCustomDepartmentDistribution,
} from '@api/crm/crm';
import ModalProtect from './ModalProtect';
import ModalAllot from './ModalAllot';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pageNo: 1,
      total: 0,
      modalVisible: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getProtection();
  }

  saveProtection = params => {
    querySaveCustomDepartmentDistribution(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getProtection();
        this.handleModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  getProtection = pageNo => {
    const no = this.state.pageNo;
    const current = pageNo || no;
    this.setState({
      pageNo: current,
    });
    queryCustomProtectionList({
      condition: this.condition || '',
      type: this.type || '',
      start: current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  handleModalVisible = (flag, uuid) => {
    this.uuid = uuid;
    this.setState({
      modalVisible: !!flag,
    });
  };

  handleSubmit = params => {
    this.saveProtection(params);
  };

  handleAllotSubmit = params => {
    querySaveCustomDepartmentDistribution(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getProtection();
        this.handleAllotModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  handleSearch = e => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      this.condition = values.condition;
      this.getProtection(1);
    });
  };

  confirm = customUuid => {
    return e => {
      queryCancelCustomProtection({
        customUuid,
      }).then(res => {
        if (res.statusCode === 200) {
          message.success(res.message);
          this.getProtection();
          this.handleModalVisible(false);
        } else {
          message.error(res.message);
        }
      });
    };
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSearch}>
        <Row gutter={{ md: 8, lg: 24, xl: 48 }} style={{ minWidth: '650px' }}>
          <Col md={8} sm={24} style={{ minWidth: '400px' }}>
            <FormItem label="客户名称">
              {getFieldDecorator('condition')(
                <Input placeholder="请输入" style={{ minWidth: '200px' }} />,
              )}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <span className="submitButtons">
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
                重置
              </Button>
            </span>
          </Col>
        </Row>
      </Form>
    );
  };

  handleAllotModalVisible = (flag, record) => {
    record = record || {};
    record.protectionUser = record.protectUuid;
    this.record = record;
    this.setState({
      allotModalVisible: !!flag,
    });
  };

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '客户名称',
        dataIndex: 'name',
      },
      {
        title: '行业',
        dataIndex: 'type',
      },
      {
        title: '来源渠道',
        dataIndex: 'origin',
      },
      {
        title: '保护人名称',
        dataIndex: 'protectName',
      },
      {
        title: '保护时间',
        dataIndex: 'protectDate',
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>,
      },
      {
        title: '保护到期时间',
        dataIndex: 'maturityDate',
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>,
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <span>
              <a onClick={() => this.handleAllotModalVisible(true, record)}>分配</a>
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, modalVisible, total, pageNo, allotModalVisible } = this.state;
    const parentProps = {
      handleModalVisible: this.handleModalVisible,
      handleSubmit: this.handleSubmit,
      uuid: this.uuid,
    };
    const parentProps2 = {
      handleModalVisible: this.handleAllotModalVisible,
      handleSubmit: this.handleAllotSubmit,
      record: this.record,
    };
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.getProtection(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListForm">{this.renderSearchForm()}</div>
          <div className="tableListOperator">
            <Button type="primary" onClick={() => this.handleModalVisible(true)}>
              添加
            </Button>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {modalVisible ? <ModalProtect {...parentProps} /> : null}
        {allotModalVisible ? <ModalAllot {...parentProps2} /> : null}
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/custom/protectWatch/Index.js